import React ,{useEffect,useState}from 'react'
import { AddUpdate } from '../../../ApiMethods/ApiMethods'
import DataTable from 'react-data-table-component'
import { customStyles } from '../Utility/Utility'

const WaitingListHistory = () => {
    const [data,setData]=useState([])
    const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
    const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);
    const [AstroId,setAstroId]=useState("");
    const [UserId,setUserId]=useState("");
    
    const WailtinglistHistory=async()=>{
     
        try{
       const payload={
        UserID:UserId,AstroID:AstroId,DeletedDateFrom:startTime,DeletedDateTo:endTime
        }
        const res=await AddUpdate("WaitingList/GetData_WaitingListHistory",payload)

        if(res?.data?.data){
             const datas=JSON ?.parse(res?.data?.data);
        const finaldata=datas?.Table;
        setData(finaldata)
        }
        else{
            setData([])
        }
    
       

        }
        catch(err){
            console.log("error",err)
        }
       
    }
    const columns=[
      
 {
      name: "Astrologer Name",
      selector: (row) => row.Astroname,
      sortable: true,
     
      cell: (row) => (
        <div >
          <div>
            {row.Astroname}({row.AstroId})
          </div>
          <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
            {row.AstroMobileno}
          </div>
        </div>
      ),
    },

{
      name: "Username Name",
      selector: (row) => row.Username,
      sortable: true,
     
      cell: (row) => (
        <div >
          <div>
            {row.Username}({row.UserId})
          </div>
          <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
            {row.UserMobileno}
          </div>
        </div>
      ),
    },
 {
        name: "Type",   
        selector: (row) => row.Type,
        sortable: true,
            },

            {
                name: "Status",   
                selector: (row) => row.Status,
                sortable: true,
            },
             {
     name: "Deleted Date",
     selector: (row) => row.DeletedDate,
  sortable: true,
  cell: (row) => {
    const date = new Date(row.DeletedDate);
    return date.toLocaleString("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  },
}

    ]


useEffect(()=>{
    WailtinglistHistory()
    
},[])
const handleSearch=()=>{
    WailtinglistHistory();
}

  return (
      <>
      <div className="form-group  main_card">
      <h2 style={{ color: "#f7931e", fontWeight: 700 }}>WaitingList History</h2>
       
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>


          <div className='col-3'>
            <label className='form-label'>End Time</label>
            <input type="date"
              value={endTime}
              onChange={(e)=>setEndTime(e.target.value)}/>

          </div>
          </div>
 <div className="row mt-3">
            <div className='col-3'>
            <label className='form-label'>Astrologer ID</label>
            <input type="number"
              value={AstroId}
              placeholder='Enter your Astrologer Id'
              onChange={(e)=>setAstroId(e.target.value)}/>
            </div>

            <div className='col-3'>
            <label className='form-label'>User ID</label>
            <input type="number"
              value={UserId}
              placeholder='Enter your User Id'
              onChange={(e)=>setUserId(e.target.value)}/>
          </div>
      <div className="col-auto">
            <button className="btn btn-primary ms-2 mt-3"
             onClick={handleSearch}
             >
              Search
            </button>
          
          </div>

        </div>
        </div>
        
    
     <div className="col-12 mt-2  main_card">
            
              <DataTable
                dense
                data={data || []}
                columns={columns}
                selectableRowsHighlight
                pagination
                customStyles={customStyles}
                persistTableHead={true}
                noDataComponent={"There are no data to display"}
              />
           
          </div>
    </>
  )
}

export default WaitingListHistory